import { render, staticRenderFns } from "./firerecord.vue?vue&type=template&id=c4fe99cc&scoped=true&"
import script from "./firerecord.vue?vue&type=script&lang=js&"
export * from "./firerecord.vue?vue&type=script&lang=js&"
import style0 from "./firerecord.vue?vue&type=style&index=0&id=c4fe99cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fe99cc",
  null
  
)

export default component.exports